module.exports = __webpack_public_path__ + "p_r.f4dd338a.png";